import React, { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Hero from './Pages/LandingPage/Hero';
import Dashboard from './Pages/Dashboard/Dashboard';
import Studentexplore from './Pages/studentexplore/studentexplore';
import Footer from './components/Footer/Footer';
import ClientPage from './Pages/ClientPage/ClientPage';
import ViewBooking from './components/Booking/ViewBooking';
import RescheduleBooking from './components/Booking/RescheduleBooking';
import CancelBooking from './components/Booking/CancelBooking';
import PartnerRegistration from './Pages/PartnerRegistration/PartnerRegistration';
import ClientRegistration from './Pages/PartnerRegistration/ClientRegistration';
import ProtectedRoute from './components/restrictions/ProtectedRoute';
import ProfileProtectedRoute from './components/restrictions/ProfileProtectedRoute';
import PartnerAdminVenue from './Pages/PartnerAdmin/partneradminvenue';
import PartnerAdminEvent from './Pages/PartnerAdmin/PartnerAdminEvent';
import PartnerAdminTemple from './Pages/PartnerAdmin/PartnerAdminTemple';
import PartnerAdminOrg from './Pages/PartnerAdmin/PartnerAdminOrg';
import Profile from './Pages/Profile/Profile';
import useScrollToTop from './hooks/useScrollToTop';
import RedirectToPartnerAdmin from './hooks/RedirectToPartnerAdmin';
import About from './Pages/about/about';
import { matchPath } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';

// RedirectWrapper Component
const RedirectWrapper = () => {
  const navigate = useNavigate();
  const { location } = useParams(); // Extract location from URL parameters

  useEffect(() => {
    const selectedLocation = localStorage.getItem('selectedLocation');
    if (!location) {
      // Redirect to /explore/:location based on localStorage or default to Chennai
      navigate(`/explore/${selectedLocation ? selectedLocation.toLowerCase() : 'chennai'}`, {
        replace: true,
      });
    }
  }, [location, navigate]);

  return null; // Return nothing since the component only handles redirection
};

// Updated App Component with Route Handling
function App() {
  const location = useLocation();
  const shouldRenderFooter = !(
    location.pathname === '/partneradmin' ||
    matchPath('/partner/registration/:registrationType', location.pathname)
  );
  useScrollToTop();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      console.log('Google Login Token:', token);

      try {
        const decodedToken = jwtDecode(token);
        console.log('Decoded Token:', decodedToken);
      } catch (error) {
        console.error('Error decoding token:', error);
      }

      localStorage.setItem('google_token', token);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [location]);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/partnerwithus" element={<ClientRegistration />} />
        <Route path="/partner/registration/:registrationType" element={<PartnerRegistration />} />
        <Route path="/explore" element={<RedirectWrapper />} /> {/* Wrapper for redirection */}
        <Route path="/explore/:location" element={<Dashboard />} /> {/* Dashboard with location */}
        <Route path="/client" element={<ClientPage />} />
        <Route path="/view-booking" element={<ViewBooking />} />
        <Route path="/reschedule-booking" element={<RescheduleBooking />} />
        <Route path="/cancel-booking" element={<CancelBooking />} />
        <Route path="/client/:id" element={<ClientPage />} />
        <Route path="/student/explore" element={<Studentexplore />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/partner/admin"
          element={<RedirectToPartnerAdmin />}
        />
        <Route
          path="/partner/admin/venue/:clientid/:venue"
          element={<ProtectedRoute><PartnerAdminVenue /></ProtectedRoute>}
        />
        <Route
          path="/partner/admin/event/:clientid/:event"
          element={<ProtectedRoute><PartnerAdminEvent /></ProtectedRoute>}
        />
        <Route
          path="/partner/admin/temple/:clientid/:temple"
          element={<ProtectedRoute><PartnerAdminTemple /></ProtectedRoute>}
        />
        <Route
          path="/partner/admin/org/:orgId/:orgName"
          element={<ProtectedRoute><PartnerAdminOrg /></ProtectedRoute>}
        />
        <Route
          path="/profile"
          element={
            <ProfileProtectedRoute>
              <Profile />
            </ProfileProtectedRoute>
          }
        />
      </Routes>

      {shouldRenderFooter && <Footer />}
    </div>
  );
}

const AppWithRouter = () => (
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <Router>
      <App />
    </Router>
  </GoogleOAuthProvider>
);

export default AppWithRouter;
